import React from "react";
import RangeInput from "../items/RangeInput";
import ToggleContainer from "../items/ToggleSwitch";

import "../style/LeftSection.css";
import "../style/CategoryLocationSelection.css"
import Icon from "../../../common/components/Icon";

import { t } from "i18next";

function LeftSections({
    openCategoryModal,
    selectedCategory,
    resetFilters,
    minPrice,
    maxPrice,
    onPriceChange,
    isContract,
    onContractToggle,
}) {
    return (
        <div className="filter_section_content">
            <div className="filter_section_content_top">
                <h2>{t('filters')}</h2>
                <p className="click link" onClick={resetFilters}>
                    {t('reset')}
                </p>
            </div>
            <div className="filter_section_content_card">
                <div className="selection-container">
                    <h3>{t('selectCategory')}</h3>
                    <button
                        className="open_modal_button filter whitespace-nowrap overflow-hidden text-ellipsis"
                        onClick={openCategoryModal}
                    >
                        <span className="flex-1 text-left overflow-hidden text-ellipsis whitespace-nowrap mr-2">
                            {selectedCategory || t('selectCategory')}
                        </span>
                        <Icon src="right_arrow" alt="right" />
                    </button>
                    <hr style={{marginBottom: 20, marginTop: 20}} className="divider" />
                </div>
            </div>
            <div className="filter_section_content_bottom">
                <h3>{t('price')}</h3>
                <div className="filter_section_content_bottom_inputs">
                    <RangeInput
                        minValue={minPrice}
                        maxValue={maxPrice}
                        onMinChange={(min) => onPriceChange(min, maxPrice)}
                        onMaxChange={(max) => onPriceChange(minPrice, max)}
                    />
                </div>
                <ToggleContainer
                    isContract={isContract}
                    onContractToggle={onContractToggle}
                />
            </div>
        </div>
    );
}

export default LeftSections;